import { useContext, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { GridContext, useClientSortingPaging, usePreservedSelection } from '@bingads-webui-grid/grid-context';

export const GridDataSource = ({ onSelectChange }) => {
  const { state, dispatch } = useContext(GridContext);
  const {
    sortedColumn, pagination, sourceItemsInAllPages, selectedItemsInAllPages,
  } = state;
  const { pageNumber, pageSize } = pagination;
  const sort = useCallback((a, b) => {
    const isSortedDescending = sortedColumn.isSortedDescending ? -1 : 1;
    switch (sortedColumn.fieldName) {
      case 'AggregateMetric/AverageSearchVolume':
        return isSortedDescending * (a.AggregateMetric.AverageSearchVolume - b.AggregateMetric.AverageSearchVolume);
      default:
        return 0;
    }
  }, [sortedColumn]);

  useClientSortingPaging({
    sortFunction: sort,
  });
  usePreservedSelection();

  useEffect(() => {
    dispatch({ type: 'FINISH_LOAD_DATA', payload: { items: sourceItemsInAllPages.slice((pageNumber - 1) * pageSize, (pageNumber) * pageSize), totalCount: sourceItemsInAllPages.length } });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onSelectChange(selectedItemsInAllPages);
  }, [onSelectChange, selectedItemsInAllPages]);

  return null;
};

GridDataSource.propTypes = {
  onSelectChange: PropTypes.func.isRequired,
};
